import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { OnboardEditComponent } from '../../../Menus/Onboard/onboard.component';

@Component({
  selector: 'formly-field-file',
  template: `
  <input style="display:none" type="input" [formControl]="formControl" [formlyAttributes]="field">
<inlinefileuploader  (refresh)="refreshView()" [hasError]="formControl.errors" [disable]='formControl.disabled||formState?.disabled' [regCmpDocId]="to.regCmpDocId" (refresh)="clickEvent()" [userId]="to.userId" [multiple]="to.multiple" [pk]="selected" [status]="to.status"></inlinefileuploader>
`,
})
export class FormlyFieldFile extends FieldType {
    selected;
    constructor(private onboard: OnboardEditComponent ) {super()
  }
    
    ngOnInit(){
        this.selected = this.to.options[this.to.docType].find((x: any) =>x.regCmpDocId != null ? x.regCmpDocId == this.to.regCmpDocId :x.docId == this.to.label)        
    }
    refreshView(){
      this.onboard.getDocumentList(null)
    }
}